module.exports = __webpack_public_path__ + "static/img/video_preview2.f8bf367.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_preview2.jpg
// module id = OtPG
// module chunks = 1